/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { generateDocsUrl } from '../../../ia/util/docs';

export const links = {
  TWILIO_API_LINK: 'https://www.twilio.com/whatsapp/request-access',
  FACEBOOK_MESSENGER_MANAGER_ID_LINK: 'https://business.facebook.com/overview',
  whatsappLearnMoreNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-whatsapp'
  ),
  whatsappLearnMoreClassicIA: generateDocsUrl(
    '/assistant?topic=assistant-deploy-whatsapp'
  ),
  learnMoreWhatsAppSetupLink: generateDocsUrl(
    '/?topic=assistant-deploy-whatsapp#deploy-whatsapp-setup'
  ),
  learnMoreWhatsAppSetupNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-whatsapp#deploy-whatsapp-setup'
  ),
  learnMoreWhatsAppClickToChatLink: generateDocsUrl(
    '/?topic=assistant-deploy-whatsapp#deploy-whatsapp-click-to-chat'
  ),
  learnMoreWhatsAppClickToChatNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-whatsapp#deploy-whatsapp-click-to-chat'
  ),
  learnMoreWhatsAppChannelTransferLink: generateDocsUrl(
    '/?topic=assistant-dialog-overview#dialog-overview-add-channel-transfer'
  )
};
